import { render } from "./SegmentControl.vue?vue&type=template&id=3c9f0631&scoped=true"
import script from "./SegmentControl.vue?vue&type=script&lang=js"
export * from "./SegmentControl.vue?vue&type=script&lang=js"

import "./SegmentControl.vue?vue&type=style&index=0&id=3c9f0631&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9f0631"]])

export default __exports__